<template>
  <div class="about-page">
    <!-- 背景装饰：柔光渐变圆与浮动点阵 -->
    <div class="bg-decor decor-1" aria-hidden="true"></div>
    <div class="bg-decor decor-2" aria-hidden="true"></div>
    <div class="bg-grid" aria-hidden="true"></div>
    <!-- 顶部横幅 -->
    <div class="about-banner">
      <div class="banner-content" data-aos="fade-down">
        <h1>学校介绍</h1>
        <p>传承艺术精髓 · 创新艺术教育</p>
        <div class="banner-badges">
          <span class="badge">二十余年专注</span>
          <span class="badge">优秀师资</span>
          <span class="badge">完善设施</span>
        </div>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <div class="container">
        <router-link to="/" class="crumb">首页</router-link>
        <span class="crumb current">学校介绍</span>
      </div>
    </nav>

    <div class="container">
      <!-- 学校概况 -->
      <section class="about-section overview" data-aos="fade-up">
        <div class="section-header">
          <h2>学校概况</h2>
          <div class="divider"></div>
        </div>
        <div class="section-content">
          <div class="overview-image">
            <img src="@/assets/resources/学校环境介绍/1bfdbe51ccb5b7cd37e21ceef838e9c.jpg" alt="学校概况">
          </div>
          <div class="overview-text">
            <p data-aos="fade-right">&emsp;&emsp;长治市杉原美术培训学校是经长治市教育局批准成立的一所专注于美术高考的专业教育机构，于2003年5月开始办学。经过二十余年的不懈努力，现已成为山西省美术教育最具竞争力的知名学校！</p>
            <p data-aos="fade-right">&emsp;&emsp;我校以“用更优的美术教育圆更多学子的大学梦想”作为学校使命，继承“为了学生一切，一切为了学生”的服务理念，以“励志、勤学、尚美、卓越”作为学校师生的总要求，以“引导学生走上艺术道路，唤醒学生对艺术和人生的思考”作为我们的办学理念。  </p>
            <p data-aos="fade-right">&emsp;&emsp;我校现有专职教师30余人，教师均毕业于全国各大艺术院校。建校20余年来，每年培训的学员约300余人，三次夺得山西省美术统考第一名，为长治地区的美术教育发展做出了贡献！  </p>
            <p data-aos="fade-right">&emsp;&emsp;杉原美术学校经过二十余年的摸索、研究，已经形成了一套先进完整的教学体系，使求学于此的每位学子都能得到耐心的辅导、精心的培育、细心的呵护、贴心的教诲，学子因选择杉原而幸运，杉原因学子成长而精彩。杉原人将不负众望、恪尽职守、立足上党、放眼三晋，努力攀登新的高峰！  </p>
            <p data-aos="fade-right">&emsp;&emsp;你若来，我便帮你去你想去的未来！</p>
            <div class="stats-grid">
              <div class="stat-item">
                <div class="stat-number">20+</div>
                <div class="stat-label">年办学历史</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">30+</div>
                <div class="stat-label">专业教师</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">300+</div>
                <div class="stat-label">在校学生</div>
              </div>
              <!--<div class="stat-item">-->
              <!--  <div class="stat-number">95%</div>-->
              <!--  <div class="stat-label">升学率</div>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </section>

      <!-- 历史沿革 -->
      <section class="about-section history" data-aos="fade-up" v-if="false">
        <div class="section-header">
          <h2>历史沿革</h2>
          <div class="divider"></div>
        </div>
        <div class="timeline">
          <div class="timeline-item" v-for="(item, index) in historyItems" :key="index"
               :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'" :data-aos-delay="index * 20">
            <div class="timeline-year">{{ item.year }}</div>
            <div class="timeline-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 办学理念 -->
      <section class="about-section philosophy" data-aos="fade-up">
        <div class="section-header">
          <h2>办学理念</h2>
          <div class="divider"></div>
        </div>
        <div class="philosophy-content">
          <div class="philosophy-card shiny" v-for="(p, i) in philosophies" :key="i" :data-aos="'zoom-in'" :data-aos-delay="i * 80">
            <div class="philosophy-icon"><i :class="p.icon"></i></div>
            <h3>{{ p.title }}</h3>
            <p>{{ p.description }}</p>
          </div>
        </div>
      </section>

      <!-- 领导寄语 -->
      <section class="about-section message" data-aos="fade-up">
        <div class="section-header">
          <h2>校长寄语</h2>
          <div class="divider"></div>
        </div>
        <div class="message-content">
          <div class="dean-image">
            <img src="@/assets/resources/教师介绍/教师形象照/刘俊.jpg" alt="校长照片">
            <div class="dean-info">
              <h4>刘俊</h4>
              <p>杉原美校校长</p>
            </div>
          </div>
          <div class="message-text">
            <blockquote>
              "艺术教育不仅是技艺的传授，更是灵魂的对话。我们致力于为学生提供一个开放、包容的创作环境，让每一份艺术天赋都能得到充分发展。"
            </blockquote>
            <p>&emsp;&emsp;在杉原美校，我们秉承"厚德博艺，创新致远"的校训，坚持艺术教育与时代发展相结合，传统技艺与现代创新相融合，培养具有国际视野和创新精神的艺术人才。</p>
            <p>&emsp;&emsp;学校注重学生的个性化培养，为每位学生提供量身定制的成长路径。我们相信，艺术教育的真谛在于激发创造力，培养独立思考能力，塑造完整人格。</p>
          </div>
        </div>
      </section>

      <!-- 荣誉展示 -->
      <section class="about-section honors" data-aos="fade-up">
        <div class="section-header">
          <h2>学校荣誉</h2>
          <div class="divider"></div>
        </div>
        <div class="honors-gallery">
          <Gallery :images="honorImages" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'AboutPage',
  components: {
    Gallery
  },
  data() {
    return {
      historyItems: [
        {
          year: '2003',
          title: '杉原画室创立',
          description: '在长治市东大街路渠巷的小院子里创办，学生仅有30人，开启梦想之路。'
        },
        {
          year: '2004',
          title: '首次统考全省第一',
          description: '王旭峰同学为画室夺得第一个全省统考第一名，学生人数增加至60人，画室迎来良好开端。'
        },
        {
          year: '2005',
          title: '迁至安古巷24号',
          description: '画室搬至宽敞的安古巷24号小院，学生人数达到80人。'
        },
        {
          year: '2006',
          title: '创佳绩并迁至安古巷26号',
          description: '秦丽同学以269.7分获长治地区第一，全市前十名我校独占5名，画室品牌声誉提升，迁入安古巷26号新校区。'
        },
        {
          year: '2007',
          title: '新校区投入使用',
          description: '安古巷26号校区启用，面积近300平米，高三集训人数达230人，王栩敏考取中央美术学院，教师人数增至10人。'
        },
        {
          year: '2008',
          title: '再获全省统考状元',
          description: '林伟静同学271.1分夺山西省第一，张晨飞全市第三，同年开办少儿美术培训校区。'
        },
        {
          year: '2009',
          title: '规模与成绩双提升',
          description: '学生人数突破200人，教师增至15人，统考过线率99%，位居全市第一。'
        },
        {
          year: '2010',
          title: '荣誉与奖项',
          description: '张露、任鹏飞同学并列全市第三，获得全国十三届中学生美术大赛集体一等奖及长治市“十佳”民办教育机构称号。'
        },
        {
          year: '2012',
          title: '学子考取名校',
          description: '张美昕考取四川美术学院，任越同学获全市第三名。'
        },
        {
          year: '2013',
          title: '全省统考第一',
          description: '再次夺得全省统考第一名，画室被评为“百姓心中满意品牌”。'
        },
        {
          year: '2014',
          title: '潞城分校区成立',
          description: '杉原创办第一个高中潞城分校区。'
        },
        {
          year: '2015',
          title: '新校区及襄垣分校区',
          description: '原二层校区扩建为设施完善的新校区，同时创办襄垣分校区。'
        },
        {
          year: '2016',
          title: '联考成绩领先',
          description: '联考本科率全市第一，八大美院校考合格证达16个，教师人数增至20余人，并开办潞城少儿美术分校区，获“一千零一个梦公益画室”称号。'
        },
        {
          year: '2017',
          title: '行业认可',
          description: '获长治市城区民办教育协会常务理事单位，成为山西美术联盟会员单位。'
        },
        {
          year: '2018',
          title: '扩展分校区',
          description: '教学成绩达线人数100%，陆续开办长钢、平顺、屯留、壶关高中分校区及北校区少儿分校区。'
        },
        {
          year: '2019',
          title: '迁至紫金东街258号',
          description: '画室搬迁至紫金东街258号，稳定办学至今。'
        },
        {
          year: '2020',
          title: '统考成绩辉煌',
          description: '最高分243分进入长治地区前五名，本科率81.8%。'
        },
        {
          year: '2021',
          title: '统考高分集中',
          description: '最高分253.4分，230分以上18人，220分以上69人，成绩喜人。'
        },
        {
          year: '2022',
          title: '多名高分学子',
          description: '张明睿253.4分夺长治市第一，靳紫琼251.2分获前三名，达线率83%。'
        },
        {
          year: '2023',
          title: '统考继续领先',
          description: '最高分251.4分，达线率83%。'
        },
        {
          year: '2024',
          title: '统考再创新高',
          description: '马亚茜夺得最高分254分，210分以上231人，达线率94.5%。'
        },
        {
          year: '2025',
          title: '本科通过率96%',
          description: '画室共180人，172人达本科线，230分以上51人，同时创办平顺分校区。'
        }
      ],
      philosophies: [
        {
          title: '传承与创新',
          description: '尊重艺术传统，鼓励创新表达，在传承中发展，在发展中传承。',
          icon: 'fas fa-arrows-rotate'
        },
        {
          title: '个性发展',
          description: '因材施教，尊重每个学生的艺术个性，发掘独特艺术语言。',
          icon: 'fas fa-user-astronaut'
        },
        {
          title: '实践育人',
          description: '强调艺术实践，通过创作实践培养艺术感知力和表现力。',
          icon: 'fas fa-paintbrush'
        },
        {
          title: '开放包容',
          description: '营造多元文化氛围，吸收各种艺术流派精华，兼容并蓄。',
          icon: 'fas fa-globe'
        }
      ],
      honorImages: [
        {
          src: require('@/assets/images/honor1.png'),
          alt: '全国美展金奖',
          caption: '全国美术作品展览金奖'
        },
        {
          src: require('@/assets/images/honor2.png'),
          alt: '教学成果奖',
          caption: '省级教学成果一等奖'
        },
        {
          src: require('@/assets/images/honor3.png'),
          alt: '优秀学校奖',
          caption: '全国艺术教育先进单位'
        },
        {
          src: require('@/assets/images/honor4.png'),
          alt: '国际展览',
          caption: '国际艺术双年展参展证书'
        }
      ]
    }
  },
  created() {
    this.loadHonorImages()
  },
  methods: {
    loadHonorImages() {
      const requireContext = require.context(
          '@/assets/resources/每年喜报/',
          false,
          /\.jpg$/
      );

      const images = requireContext.keys().map(key => ({
        src: requireContext(key),
        // src: 'https://www.czsyhs.com/每年喜报/' + key,
        alt: '宣传页',
        // caption: key.replace('./', '').replace('.jpg', '')
        caption: null
      }));

      this.honorImages = images
    },
  }
}
</script>

<style scoped>
.about-page {
  color: #333;
  position: relative;
  overflow: hidden;
}

.bg-decor {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.35;
}
.decor-1 { width: 420px; height: 420px; top: -120px; left: -120px; background: radial-gradient(circle, rgba(66,185,131,0.55), rgba(66,185,131,0)); }
.decor-2 { width: 480px; height: 480px; bottom: -180px; right: -180px; background: radial-gradient(circle, rgba(44,62,80,0.5), rgba(44,62,80,0)); }

.bg-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
  background-size: 22px 22px;
  pointer-events: none;
}

/* 顶部横幅样式 */
.about-banner {
  height: 400px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('@/assets/images/common-banner.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.banner-badges { margin-top: 14px; display: inline-flex; gap: 10px; }
.badge { padding: 6px 10px; border-radius: 999px; font-size: 12px; letter-spacing: 0.06em; background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22); }

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-content p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 面包屑导航 */
.breadcrumb {
  padding: 8px 0;
  background: transparent;
  margin: 6px 0 24px;
  font-size: 0.95rem;
}

.breadcrumb .container { display: flex; align-items: center; gap: 10px; color: #7f8c8d; }
.breadcrumb .crumb { color: var(--default-red-color); text-decoration: none; position: relative; padding-right: 16px; }
.breadcrumb .crumb::after { content: '/'; position: absolute; right: 4px; color: #9aa6ac; }
.breadcrumb .crumb:last-of-type::after { content: none; }
.breadcrumb .current { color: #9aa6ac; }

/* 通用区块样式 */
.about-section {
  margin-bottom: 60px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2.2rem;
  color: #2c3e50;
  margin-bottom: 15px;
}

.divider {
  width: 80px;
  height: 3px;
  background-color: var(--default-red-color);
  margin: 0 auto;
}

/* 学校概况样式 */
.overview .section-content {
  display: flex;
  gap: 40px;
  align-items: center;
}

.overview-image {
  flex: 1;
}

.overview-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.overview-text {
  flex: 1;
}

.overview-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #555;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: var(--default-red-color);
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  color: #7f8c8d;
}

/* 历史沿革样式 */
.timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding-left: 50px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: var(--default-red-color);
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.timeline-year {
  position: absolute;
  left: -50px;
  top: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--default-red-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  box-shadow: 0 0 0 4px white, 0 0 0 6px var(--default-red-color);
}

.timeline-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  border: 1px solid #eef2ef;
}
.timeline-item:hover { transform: translateY(-4px); }

.timeline-content h3 {
  color: #2c3e50;
  margin-bottom: 10px;
}

.timeline-content p {
  color: #555;
  line-height: 1.6;
}

/* 办学理念样式 */
.philosophy-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
}

.philosophy-card {
  text-align: center;
  padding: 30px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
  position: relative;
  overflow: hidden;
}

.philosophy-card:hover {
  transform: translateY(-5px);
}

/* 闪光涂层效果 */
.philosophy-card.shiny::after {
  content: '';
  position: absolute;
  top: -100%;
  left: -100%;
  width: 200%;
  height: 200%;
  background: linear-gradient(120deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 60%);
  transform: rotate(10deg);
  transition: transform 0.6s ease, opacity 0.6s ease;
  opacity: 0;
}
.philosophy-card.shiny:hover::after { transform: rotate(10deg) translate(20%,20%); opacity: 1; }

.philosophy-icon {
  font-size: 2.5rem;
  color: var(--default-red-color);
  margin-bottom: 20px;
}

.philosophy-card h3 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.philosophy-card p {
  color: #7f8c8d;
  line-height: 1.6;
}

/* 领导寄语样式 */
.message-content {
  display: flex;
  gap: 40px;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
}

.dean-image {
  flex: 1;
  text-align: center;
}

.dean-image img {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dean-info h4 {
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 5px;
}

.dean-info p {
  color: #7f8c8d;
  margin-bottom: 5px;
  font-size: 0.9rem;
}

.message-text {
  flex: 1;
}

.message-text blockquote {
  font-size: 1.2rem;
  color: #2c3e50;
  border-left: 4px solid var(--default-red-color);
  padding-left: 20px;
  margin-bottom: 20px;
  font-style: italic;
}

.message-text p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 15px;
}

/* 荣誉展示样式 */
.honors-gallery {
  max-width: 1000px;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .overview .section-content {
    flex-direction: column;
  }

  .message-content {
    flex-direction: column;
  }

  .dean-image {
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .about-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2.5rem;
  }

  .banner-content p {
    font-size: 1.2rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .timeline {
    padding-left: 35px;
  }

  .timeline::before {
    left: 20px;
  }

  .timeline-year {
    left: -30px;
    width: 26px;
    height: 26px;
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .about-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .section-header h2 {
    font-size: 1.8rem;
  }

  .philosophy-content {
    grid-template-columns: 1fr;
  }
}
</style>
